import { useEffect, useRef, useState } from "react";

const Ring = ({ progress }: { progress: number }) => {
    const pathRef = useRef<SVGSVGElement>(null);
    const [ pathLength, setPathLength ] = useState(0);
    const [ currentProgress, setCurrentProgress ] = useState(0);

    useEffect(() => {
      if (pathRef.current) {
        setPathLength(pathRef.current.clientHeight);
      }
    }, [pathRef]);

    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentProgress(prev => {
          if (prev < progress) {
            return prev + 1;
          } else {
            clearInterval(interval);
            return prev;
          }
        });
      }, 16);

      return () => clearInterval(interval);
    }, [progress]);

    const getProgressPathData = (progress: number) => {
      const center = 60;
      const outerRadius = 58;
      const innerRadius = 54; // 58 - 16 (толщина кольца)
      
      // Начинаем с левой точки (270 градусов) и движемся по часовой стрелке
      const startAngle = 180;
      const endAngle = startAngle + (progress * 360) / 100;
      
      const startAngleRad = (startAngle * Math.PI) / 180;
      const endAngleRad = (endAngle * Math.PI) / 180;
      
      // Внешняя дуга
      const outerStartX = center + outerRadius * Math.cos(startAngleRad);
      const outerStartY = center + outerRadius * Math.sin(startAngleRad);
      const outerEndX = center + outerRadius * Math.cos(endAngleRad);
      const outerEndY = center + outerRadius * Math.sin(endAngleRad);
      
      // Внутренняя дуга (в обратном направлении)
      const innerEndX = center + innerRadius * Math.cos(endAngleRad);
      const innerEndY = center + innerRadius * Math.sin(endAngleRad);
      const innerStartX = center + innerRadius * Math.cos(startAngleRad);
      const innerStartY = center + innerRadius * Math.sin(startAngleRad);
      
      const largeArcFlag = progress > 50 ? 1 : 0;
      
      if (progress === 0) return "";
      if (progress === 100) {
        return "M120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60ZM4.00988 60C4.00988 90.9225 29.0775 115.99 60 115.99C90.9225 115.99 115.99 90.9225 115.99 60C115.99 29.0775 90.9225 4.00988 60 4.00988C29.0775 4.00988 4.00988 29.0775 4.00988 60Z";
      }
      
      return `M ${outerStartX} ${outerStartY}
              A ${outerRadius} ${outerRadius} 0 ${largeArcFlag} 1 ${outerEndX} ${outerEndY}
              L ${innerEndX} ${innerEndY}
              A ${innerRadius} ${innerRadius} 0 ${largeArcFlag} 0 ${innerStartX} ${innerStartY}
              Z`;
    };

  return (
    <svg width="100%" height="100%" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" ref={pathRef}>
        <path d="M120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60ZM4.00988 60C4.00988 90.9225 29.0775 115.99 60 115.99C90.9225 115.99 115.99 90.9225 115.99 60C115.99 29.0775 90.9225 4.00988 60 4.00988C29.0775 4.00988 4.00988 29.0775 4.00988 60Z" fill="#4A0066"/>
        <path d={getProgressPathData(currentProgress)} fill="url(#paint0_linear_824_20214)"/>
        
        <defs>
        <linearGradient id="paint0_linear_824_20214" x1="120" y1="60" x2="0" y2="60" gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFED00"/>
            <stop offset="1" stop-color="#FF00F3"/>
        </linearGradient>
        </defs>
    </svg>
  )
}

export default Ring

